import styled from 'styled-components';

export const ModalContent = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  width: 90%;
  max-width: 360px;
  margin: auto;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15);
`;

export const ModalTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 4px 0;
  text-align: center;
`;

export const ModalSubtitle = styled.div`
  font-size: 12px;
  color: #666;
  text-align: center;
  margin: 0 0 16px 0;
`;

export const MethodOption = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1.5px solid ${props => props.selected ? '#d81b60' : '#e0e0e0'};
  background: ${props => props.selected ? '#fdf2f5' : '#ffffff'};
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
`;

export const MethodInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MethodTitle = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #222;
`;

export const MethodSubtitle = styled.span`
  font-size: 11px;
  color: #666;
  margin-top: 2px;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
  align-items: center;
`;
